<template>
  <div class="container">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Settings
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="card-header-title">
          Account
        </div>
      </div>
      <div
        class="card-content"
        style="background-color: #FFFFDD"
      >
        <Account />
      </div>
    </div>

    <div
      class="card"
      v-if="$store.state.chargifyUrl"
    >
      <div class=" card-header">
        <div class="card-header-title">
          Billing
        </div>
      </div>
      <div class="card-content">
        <Billing />
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="card-header-title">
          Preferences
        </div>
      </div>
      <div
        class="card-content"
        style="background-color: #FFFFDD"
      >
        <Preferences />
      </div>
    </div>
  </div>
</template>

<script>
import Preferences from "@/components/settings/Preferences.vue";
import Account from "@/components/settings/Account.vue";
import Billing from "@/components/settings/Billing.vue";

export default {
  components: {
    Preferences,
    Account,
    Billing
  },

  props: {
    open: true
  },

  mounted() {
    this.$store.dispatch("getChargifyUrl", this.$store.getters.session.user.id);
  }
};
</script>

<style>
</style>
